<template>
  <item-nav :id="$attrs['id']">
    <item-nav-item :label="$t('layout.nav.admin.taxNav.overview')" link="taxes" />
    <item-nav-group v-if="!isEmpty(taxes)" :open="true" :label="$t('layout.nav.admin.taxNav.taxes')">
      <template v-for="tax in taxes" v-if="!tax.deleted">
        <item-nav-group-item :label="getName(tax.name)" :params="routeParams(tax.id)" :key="tax.id" link="tax" />
      </template>
    </item-nav-group>

    <item-nav-group v-if="!isEmpty(deletedTaxes)" :label="$t('layout.nav.admin.taxNav.deletedTaxes')">
      <item-nav-group-item v-for="tax in deletedTaxes"
                           :label="getName(tax.name)"
                           :params="routeParams(tax.id)"
                           :key="tax.id"
                           link="tax" />
    </item-nav-group>

  </item-nav>
</template>

<script>

import { cloneDeep, isNil, isEmpty, keyBy, sortBy } from 'lodash';
import ItemNavGroup from '../ItemNavGroup';
import ItemNavGroupItem from '../ItemNavGroupItem';
import HotelmeisterMixin from '../../../../../mixins/HotelmeisterMixin';
import HotelSettingsMixin from '../../../../../mixins/HotelSettingsMixin';

export default {
  name: 'TaxNav',
  components: { ItemNavGroupItem, ItemNavGroup },

  mixins: [HotelmeisterMixin],
  props: [],

  data() {
    return {
      taxes: [],
    };
  },

  computed: {
    deletedTaxes: function () {
      return this.taxes.filter(it => it.deleted === true);
    },
  },

  created: function () {
    this.updateTaxes();

    this.$serviceBus.$on('tax.list', (data) => {
      if (isNil(data)) {
        this.updateTaxes();
      } else {
        this.taxes = sortBy(data, ['sort', 'taxType', `name.${this.hotelSettings.details.primaryLanguage}`]);
      }
    });
  },

  mounted: function () {
    this.$emit('widenav', true);
  },

  methods: {
    updateTaxes() {
      this.axios.get(this.serviceUrls.tax.list(this))
        .then((response) => {
          this.taxes = sortBy(response.data.data, ['sort', 'taxType', `name.${this.hotelSettings.details.primaryLanguage}`]);
        });
    },
    getName(name) {
      if (isNil(name)) return '-';
      let ret = null;

      ret = name[this.$shortLocale] || name[this.hotelSettings.details.primaryLanguage];

      if (!isEmpty(ret)) return ret;

      return name[this.hotelSettings.details.primaryLanguage];
    },
    routeParams(taxId) {
      return {
        taxId: taxId,
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  // @import '~styles/main';
</style>



// WEBPACK FOOTER //
// src/components/lib/layout/nav/admin/TaxNav.vue